<template>
  <div class="flex items-center gap-2">
    <span>{{ label }}</span>
    <CHelpText v-if="hasInfo">
      <template #default>
        <slot name="info" />
      </template>
    </CHelpText>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'

import CHelpText from '@lib/components/CHelpText/CHelpText.vue'

defineProps<{
  label: string
}>()

const slots = useSlots()
const hasInfo = computed(() => !!slots.info)
</script>
